var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Menu'),_c('Header'),_c('v-main',[_c('router-view')],1),_c('Footer'),_c('Overlay',{ref:"overlay"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }